import React from "react"
import { IoGlobeOutline, IoSearchSharp } from "react-icons/io5"
import { useLocaleDialog } from "../../../context/LocaleDialogContext"
import { usePageLocale } from "../../../context/PageContext"
import { useUserPreferences } from "../../../context/UserContext"
import useDatoMicrocopy from "../../../hooks/useDatoMicrocopy"
import useRoutePath from "../../../hooks/useRoutePath"
import Button from "../../atoms/Button"
import { getLangTitle, getLocaleAreaTitle } from "../localeDialog/localeLabels"
import * as styles from "./TopNav.module.scss"

// type TopNavProps = {}

const TopNav = (/* props: TopNavProps */) => {
  const locale = usePageLocale()
  const userPrefs = useUserPreferences()
  const [, setLocaleDialogOpen] = useLocaleDialog()

  const t = useDatoMicrocopy("common", locale)
  //const { productRoot_originalId } = React.useContext(PageContext)
  // tuotehakusivu
  const getRoutePath = useRoutePath()
  const productPagePath = getRoutePath("19682286", locale)

  /**
   * Show actual page locale as users language here because that's what's actually used everywhere.
   * Re-evaluate when User Preferences vs. Page locale conflicts are resovled somehow.
   */
  const language = locale || userPrefs.language // TODO `locale` is always set here?

  return (
    <nav className={styles.container} aria-label={t("mainNav.label.aria", "Main")}>
      <ul>
        <li>
          <button className={styles.location} onClick={() => setLocaleDialogOpen(true)}>
            <IoGlobeOutline /> {userPrefs.localeArea ? getLocaleAreaTitle(userPrefs.localeArea) : "?"}
            {" / "}
            {getLangTitle(language) || "?"}
          </button>
        </li>
        <li className={styles.findProducts}>
          <a href={productPagePath}>
            <Button
              label={
                <>
                  <IoSearchSharp className={styles.searchIcon} />{" "}
                  {t("buttonFindProducts", "Find products", "productFinder")}
                </>
              }
              priority="primary"
              size="flat"
            />
          </a>
        </li>
      </ul>
    </nav>
  )
}

export default TopNav
